import React from 'react';
import { ComplianceCheckStatus } from '__generated__/graphql';
import { StyledAlert } from './styles';

export type ComplianceCheckBannerContent = {
  type: 'info' | 'success' | 'error';
  message: string;
  description?: React.ReactNode;
  icon?: React.ReactNode;
};

export interface ComplianceCheckStatusBannerProps {
  status?: ComplianceCheckStatus | null;
  // Copy per status. Statuses absent from the map render nothing.
  contentByStatus: Partial<
    Record<ComplianceCheckStatus, ComplianceCheckBannerContent>
  >;
}

// Generic status banner for an AI compliance check; callers supply per-status copy.
const ComplianceCheckStatusBanner: React.FC<
  ComplianceCheckStatusBannerProps
> = ({ status, contentByStatus }) => {
  const content = status ? contentByStatus[status] : undefined;
  if (!content) return null;

  return (
    <StyledAlert
      showIcon
      icon={content.icon}
      type={content.type}
      message={content.message}
      description={content.description}
    />
  );
};

export default ComplianceCheckStatusBanner;
